import { Injectable } from "@angular/core";
import { makeStateKey, TransferState } from "@angular/platform-browser";
import {
    Resolve,
    ActivatedRouteSnapshot,
    RouterStateSnapshot
} from "@angular/router";
import { CommonService } from "../../core/common/common.service";
const STATE_KEY_VENDOR_DETAIL = makeStateKey('vendorDetail');

@Injectable({
    providedIn: "root"
})
export class VendorResolverService implements Resolve<any> {
    constructor(private commonService: CommonService, private state: TransferState) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let vendorDetail = this.state.get(STATE_KEY_VENDOR_DETAIL, <any>null);
        console.log(" **** vendorDetail  ", vendorDetail);
        if (vendorDetail !== null) {
            return { vendor: vendorDetail };
        } else {
            return this.commonService.getVendorDetail().toPromise().then((response: any) => {
                this.state.set(STATE_KEY_VENDOR_DETAIL, response.vendor);
                return response;
            });
        }
    }
}